import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

const ease = [0.22, 1, 0.36, 1] as const;

interface TowerLoadingProps {
  onComplete: () => void;
}

const TowerLoading = ({ onComplete }: TowerLoadingProps) => {
  const [phase, setPhase] = useState(0);

  useEffect(() => {
    const timers = [
      setTimeout(() => setPhase(1), 80),
      setTimeout(() => setPhase(2), 260),
      setTimeout(() => setPhase(3), 480),
      setTimeout(() => { setPhase(4); onComplete(); }, 700),
    ];
    return () => timers.forEach(clearTimeout);
  }, [onComplete]);

  return (
    <AnimatePresence>
      {phase < 4 && (
        <motion.div
          className="fixed inset-0 z-[100] flex items-center justify-center"
          style={{ background: "hsl(0 0% 2%)" }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.4, ease }}
        >
          {/* Central seam */}
          <motion.div
            className="absolute left-1/2 top-0 -translate-x-1/2 w-px h-full origin-center"
            style={{ background: "linear-gradient(180deg, transparent 15%, hsl(42 80% 52% / 0.4) 40%, hsl(42 80% 52% / 0.6) 50%, hsl(42 80% 52% / 0.4) 60%, transparent 85%)" }}
            initial={{ scaleY: 0, opacity: 0 }}
            animate={{
              scaleY: phase >= 2 ? 1 : 0,
              opacity: phase >= 2 ? (phase >= 3 ? 0.3 : 1) : 0,
            }}
            transition={{ duration: 0.5, ease }}
          />

          {/* Left door */}
          <motion.div
            className="absolute top-0 left-0 w-1/2 h-full"
            style={{ background: "hsl(0 0% 2%)" }}
            animate={{ x: phase >= 3 ? "-100%" : "0%" }}
            transition={{ duration: 0.6, ease }}
          />

          {/* Right door */}
          <motion.div
            className="absolute top-0 right-0 w-1/2 h-full"
            style={{ background: "hsl(0 0% 2%)" }}
            animate={{ x: phase >= 3 ? "100%" : "0%" }}
            transition={{ duration: 0.6, ease }}
          />

          {/* Floor indicator */}
          <motion.div
            className="relative z-10 text-center"
            initial={{ opacity: 0 }}
            animate={{
              opacity: phase >= 1 ? (phase >= 3 ? 0 : 1) : 0,
              scale: phase >= 3 ? 0.9 : 1,
            }}
            transition={{ duration: 0.3, ease }}
          >
            <div className="w-2 h-2 mx-auto mb-6 rotate-45 border border-primary/50" />
            <p
              className="font-display text-[10px] tracking-[0.5em] uppercase font-semibold"
              style={{ color: phase >= 2 ? "hsl(42 65% 55%)" : "hsl(0 0% 25%)" }}
            >
              FLOOR 00
            </p>
            <p
              className="text-[8px] tracking-[0.3em] uppercase mt-2 font-light"
              style={{ color: phase >= 2 ? "hsl(0 0% 35%)" : "hsl(0 0% 15%)" }}
            >
              ACCESS GRANTED
            </p>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default TowerLoading;
